export const SMALL_ICON_BUTTON_ID_CLASSNAME = 'ua-smallIconButton';
